import React, { useState } from "react";
import {
  Box,
  Chip,
  Grid,
  Skeleton,
  Pagination,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";
import {
   DateRangeOutlined
} from "@mui/icons-material";
import {
  VisibleContent
} from "../../../../../components";
import clsx from "clsx";

const getEfficiencyColor = (value) => {
  const numValue = parseFloat(value) || 0;

  if (numValue < 0.8) {
    return { backgroundColor: "#FF3C4380", color: "#fff" };
  } else if (numValue >= 0.8 && numValue < 0.95) {
    return { backgroundColor: "#FF914799", color: "#fff" };
  } else if (numValue >= 0.95 && numValue < 1.2) {
    return { backgroundColor: "#9CF4A299", color: "#000" };
  } else if (numValue >= 1.2 && numValue <= 1.3) {
    return { backgroundColor: "#FFFB8E99", color: "#000" };
  } else if (numValue > 1.3) {
    return { backgroundColor: "#FF3C4380", color: "#fff" };
  }

  return { backgroundColor: "#f5f5f5", color: "#000" };
};

const ShopFloorEfficiency = (props) => {
  const {
    items,
    filter,
    period,
    totals,
    isLoading,
    totalPages,

    onChangFilter
  } = props;
  const classes = useStyles();

  const handelChangePage = (event, page) => {
    onChangFilter({...filter, page}, true);
  }
  const handleDateApply = (newFilter) => {
    onChangFilter(newFilter, true);
  }

  return (
    <>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item>
          <DatePeriodPicker
            filter={filter}
            period={period}
            onApply={handleDateApply}
            classes={classes}
          />
        </Grid>
        <VisibleContent visible={totalPages > 1}>
          <Grid item>
            <Pagination
              page={filter.page}
              count={totalPages}
              onChange={handelChangePage}
            />
          </Grid>
        </VisibleContent>
      </Grid>
      <Table className={classes.table}>
        <TableHead>
          <TableRow className={classes.tableHeadRow}>
            <TableCell>ФИО</TableCell>
            <TableCell>
              <div>
                <div className="--text">∑ н/ч<br/>за месяц<br/></div>
                <Chip className={classes.tableHeadChip} label="нч" sx={{background: "#FF3CBB33", color: "#FF3C43"}}/>
              </div>
            </TableCell>
            <TableCell>
              <div>
                <div className="--text">∑ времени<br/>выполнения работ<br/>за месяц<br/></div>
                <Chip className={classes.tableHeadChip} label="факт" sx={{background: "#B4D00066"}}/>
              </div>
            </TableCell>
            <TableCell>
              <div>
                <div className="--text">∑ дней в которых<br/>были открыты<br/>заявки за месяц<br/></div>
                <Chip className={classes.tableHeadChip} label="Смен" sx={{background: "transparent"}}/>
              </div>
            </TableCell>
            <TableCell>
              <div>
                <div className="--text">План = кол.-во<br/>смен x 12 часов<br/>x 0,9<br/></div>
                <Chip className={classes.tableHeadChip} label="план" sx={{background: "#D8D1FF"}}/>
              </div>
            </TableCell>
            <TableCell>
              <div>
                <div className="--text">Количество<br/>автомобилей<br/></div>
                <Chip className={classes.tableHeadChip} label="авто" sx={{background: "#74E5FF33"}}/>
              </div>
            </TableCell>
            <TableCell>
              <div>
                <div className="--text">Количество<br/>отремонтир.<br/>автомобилей<br/></div>
                <Grid container spacing={0.5} justifyContent="center" alignItems="center">
                  <Grid item>
                    <Chip className={classes.tableHeadChip} label="нч" sx={{background: "#FF3CBB33", color: "#FF3C43"}}/>
                  </Grid>
                  <Grid item>
                    <svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginBottom: -6}}>
                      <line x1="11.5449" y1="0.231283" x2="0.443301" y2="21.5093" stroke="#434146"/>
                    </svg>
                  </Grid>
                  <Grid item>
                    <Chip className={classes.tableHeadChip} label="авто" sx={{background: "#74E5FF33"}}/>
                  </Grid>
                </Grid>
              </div>
            </TableCell>
            <TableCell>
              <div>
                <div className="--text">Эффективность<br/>работ<br/></div>
                <Grid container spacing={0.5} justifyContent="center" alignItems="center">
                  <Grid item>
                    <Chip className={classes.tableHeadChip} label="нч" sx={{background: "#FF3CBB33", color: "#FF3C43"}}/>
                  </Grid>
                  <Grid item>
                    <svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginBottom: -6}}>
                      <line x1="11.5449" y1="0.231283" x2="0.443301" y2="21.5093" stroke="#434146"/>
                    </svg>
                  </Grid>
                  <Grid item>
                    <Chip className={classes.tableHeadChip} label="факт" sx={{background: "#B4D00066"}}/>
                  </Grid>
                </Grid>
              </div>
            </TableCell>
            <TableCell>
              <div>
                <div className="--text">Эффективность<br/>смен<br/></div>
                <Grid container spacing={0.5} justifyContent="center" alignItems="center">
                  <Grid item>
                    <Chip className={classes.tableHeadChip} label="нч" sx={{background: "#FF3CBB33", color: "#FF3C43"}}/>
                  </Grid>
                  <Grid item>
                    <svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginBottom: -6}}>
                      <line x1="11.5449" y1="0.231283" x2="0.443301" y2="21.5093" stroke="#434146"/>
                    </svg>
                  </Grid>
                  <Grid item>
                    <Chip className={classes.tableHeadChip} label="план" sx={{background: "#D8D1FF"}}/>
                  </Grid>
                </Grid>
              </div>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <VisibleContent visible={!isLoading}>
            {items.map((item, index) => (
              <RowItem
                key={`RowItem-${ item.mechanic_id }`}
                item={item}
              />
            ))}
            <VisibleContent visible={items.length > 0}>
              <RowItemTotal totals={totals} itemsCount={items.length}/>
            </VisibleContent>
          </VisibleContent>
          <VisibleContent visible={isLoading}>
            <RowsLoading/>
          </VisibleContent>
        </TableBody>
      </Table>
      <Box className={classes.informationChip}>
        <Grid container alignItems="center" justifyContent="center" spacing={2.5}>
          <Grid item>
            <div className="--infocartor">
              <span>{'<0,8'}</span>
              <div style={{background: "#FF3C4380"}}/>
            </div>
          </Grid>
          <Grid item>
            <div className="--infocartor">
              <span>0,8-0,95</span>
              <div style={{background: "#FF914799"}}/>
            </div>
          </Grid>
          <Grid item>
            <div className="--infocartor">
              <span>0,95-1,2</span>
              <div style={{background: "#9CF4A299"}}/>
            </div>
          </Grid>
          <Grid item>
            <div className="--infocartor">
              <span>1,2-1,3</span>
              <div style={{background: "#FFFB8E99"}}/>
            </div>
          </Grid>
          <Grid item>
            <div className="--infocartor">
              <span>{'1,3>'}</span>
              <div style={{background: "#FF3C4380"}}/>
            </div>
          </Grid>
        </Grid>
        <div className="--message">
          Меньше 0,8 - работает очень медленно - разобраться в причине (оборудование, инструмент, квалификация, норма времени).<br/>
          Больше 1,3 - очень быстро - проверить (закрытые работы, полноту и качество выполненных работ, корректность нормативных работ).
        </div>
      </Box>
    </>
  )
}
const RowItem = ({ item }) => {
  const classes = useStyles();
  return (
    <TableRow className={classes.tableBodyRow}>
      <TableCell>{item?.name || '-'}</TableCell>
      <TableCell align="center">{item?.norm_hours || '0'}</TableCell>
      <TableCell align="center">{item?.actual_hours || '0'}</TableCell>
      <TableCell align="center">{item?.days_open || '0'}</TableCell>
      <TableCell align="center">{item?.plan_hours || '0'}</TableCell>
      <TableCell align="center">{item?.cars_count || '0'}</TableCell>
      <TableCell align="center">{item?.repaired_cars_count || '0'}</TableCell>
      <TableCell align="center">
        <Chip
          label={item?.efficiency_work || '0'}
          size="small"
          className={classes.tableBodyChip}
          sx={getEfficiencyColor(item?.efficiency_work)}
        />
      </TableCell>
      <TableCell align="center">
        <Chip
          label={item?.efficiency_shifts || '0'}
          size="small"
          className={classes.tableBodyChip}
          sx={getEfficiencyColor(item?.efficiency_shifts)}
        />
      </TableCell>
    </TableRow>
  )
}
const RowItemTotal = ({totals, itemsCount}) => {
  const classes = useStyles();
  return (
    <>
      <TableRow className={clsx([classes.tableBodyRow, '--total-top'])}>
        <TableCell rowSpan={2}>
          <Box
            sx={{ fontWeight: 700, fontSize: 16, color: "#434146" }}
          >Итого по цеху</Box>
        </TableCell>
        <TableCell align="center">∑ сумма</TableCell>
        <TableCell align="center">∑ сумма</TableCell>
        <TableCell align="center">∑ сумма</TableCell>
        <TableCell align="center">∑ сумма</TableCell>
        <TableCell align="center">∑ сумма</TableCell>
        <TableCell align="center">Среднее значение</TableCell>
        <TableCell align="center">Среднее значение</TableCell>
        <TableCell align="center">Среднее значение</TableCell>
      </TableRow>
      <TableRow className={clsx([classes.tableBodyRow, '--total-bottom'])}>
        <TableCell align="center">{totals.norm_hours || '0'}</TableCell>
        <TableCell align="center">{totals.actual_hours || '0'}</TableCell>
        <TableCell align="center">{totals.days_open || '0'}</TableCell>
        <TableCell align="center">{totals.plan_hours || '0'}</TableCell>
        <TableCell align="center">{totals.cars_count || '0'}</TableCell>
        <TableCell align="center">{totals.repaired_cars_count || '0'}</TableCell>
        <TableCell align="center">
          <Chip
            label={totals.efficiency_work || '0'}
            size="small"
            className={classes.tableBodyChip}
            sx={getEfficiencyColor(totals.efficiency_work)}
          />
        </TableCell>
        <TableCell align="center">
          <Chip
            label={totals.efficiency_shifts || '0'}
            size="small"
            className={classes.tableBodyChip}
            sx={getEfficiencyColor(totals.efficiency_shifts)}
          />
        </TableCell>
      </TableRow>
    </>
  )
}
const RowsLoading = () => {
  return new Array(10).fill(0).map((_, i) => (
    <TableRow>
      <TableCell><Skeleton/></TableCell>
      <TableCell><Skeleton/></TableCell>
      <TableCell><Skeleton/></TableCell>
      <TableCell><Skeleton/></TableCell>
      <TableCell><Skeleton/></TableCell>
      <TableCell><Skeleton/></TableCell>
      <TableCell><Skeleton/></TableCell>
      <TableCell><Skeleton/></TableCell>
      <TableCell><Skeleton/></TableCell>
    </TableRow>
  ))
}
const DatePeriodPicker = ({ filter, period, onApply, classes }) => {
  const [openDateDialog, setOpenDateDialog] = useState(false);
  const [selectedYear, setSelectedYear] = useState(filter?.year || new Date().getFullYear().toString());
  const [selectedMonth, setSelectedMonth] = useState(filter?.month || (new Date().getMonth() + 1).toString().padStart(2, '0'));

  const handleOpenDateDialog = () => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    const year = filter?.year || currentYear.toString();
    let month = filter?.month || currentMonth.toString().padStart(2, '0');

    // Если выбран текущий год и месяц больше текущего, сбрасываем на текущий месяц
    if (year === currentYear.toString() && parseInt(month) > currentMonth) {
      month = currentMonth.toString().padStart(2, '0');
    }

    setSelectedYear(year);
    setSelectedMonth(month);
    setOpenDateDialog(true);
  }
  const handleCloseDateDialog = () => {
    setOpenDateDialog(false);
  }

  const handleApplyDate = () => {
    onApply({
      ...filter,
      year: selectedYear,
      month: selectedMonth
    });
    setOpenDateDialog(false);
  }

  const handleYearChange = (year) => {
    setSelectedYear(year);
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;

    // Если выбран текущий год и выбранный месяц больше текущего, сбрасываем на текущий месяц
    if (year === currentYear.toString() && parseInt(selectedMonth) > currentMonth) {
      setSelectedMonth(currentMonth.toString().padStart(2, '0'));
    }
  }

  // Генерируем список годов (последние 10 лет, максимум - текущий год)
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 11 }, (_, i) => {
    const year = currentYear - 5 + i;
    return year <= currentYear ? year.toString() : null;
  }).filter(Boolean);

  const allMonths = [
    { value: '01', label: 'Январь' },
    { value: '02', label: 'Февраль' },
    { value: '03', label: 'Март' },
    { value: '04', label: 'Апрель' },
    { value: '05', label: 'Май' },
    { value: '06', label: 'Июнь' },
    { value: '07', label: 'Июль' },
    { value: '08', label: 'Август' },
    { value: '09', label: 'Сентябрь' },
    { value: '10', label: 'Октябрь' },
    { value: '11', label: 'Ноябрь' },
    { value: '12', label: 'Декабрь' },
  ];

  // Фильтруем месяцы в зависимости от выбранного года
  const currentMonth = new Date().getMonth() + 1;
  const months = selectedYear === currentYear.toString()
    ? allMonths.filter(month => parseInt(month.value) <= currentMonth)
    : allMonths;

  return (
    <>
      <div className={classes.filterDate}>
        {period}
        <IconButton onClick={handleOpenDateDialog}>
          <DateRangeOutlined sx={{color: "#C4C4C4", fontSize: 24}}/>
        </IconButton>
      </div>

      <Dialog open={openDateDialog} onClose={handleCloseDateDialog} maxWidth="sm" fullWidth>
        <DialogTitle>Выберите период</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel>Год</InputLabel>
                <Select
                  value={selectedYear}
                  label="Год"
                  onChange={(e) => handleYearChange(e.target.value)}
                >
                  {years.map((year) => (
                    <MenuItem key={year} value={year}>
                      {year}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel>Месяц</InputLabel>
                <Select
                  value={selectedMonth}
                  label="Месяц"
                  onChange={(e) => setSelectedMonth(e.target.value)}
                >
                  {months.map((month) => (
                    <MenuItem key={month.value} value={month.value}>
                      {month.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDateDialog}>Отмена</Button>
          <Button onClick={handleApplyDate} variant="contained">Применить</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const useStyles = makeStyles(() => ({
  tableHeadRow: {
    "&.MuiTableRow-head .MuiTableCell-root": {
      borderTop: "1px solid #F3F3F3",
      borderBottom: "2px solid #C4C4C4",
      borderLeft: "none",

      color: "#434146",
      fontWeight: "400",
      textAlign: "center"
    },
    "&.MuiTableRow-head .MuiTableCell-root > div:not(.--text)": {
      height: "82px",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    "&.MuiTableRow-head .MuiTableCell-root .--text": {
      height: 54,
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      justifyContent: "center",
    },
  },
  tableHeadChip: {
    height: 23,
    marginTop: 10,

    fontSize: 14,
    color: "#434146",
    fontWeight: "400",
    textTransform: "uppercase"
  },

  tableBodyRow: {
    "&.MuiTableRow-root .MuiTableCell-root": {
      borderBottom: "1px solid #F3F3F3",
      borderLeft: "none",

      fontSize: 16,
      color: "#434146",
      fontWeight: "400"
    },
    "&.MuiTableRow-root.--total-top .MuiTableCell-root": {
      borderTop: "2px solid #C4C4C4",
      borderLeft: "none",
      height: 30,

      fontSize: 12,
      color: "#434146",
      fontWeight: "400"
    },
    "&.MuiTableRow-root.--total-bottom .MuiTableCell-root": {
      fontSize: 16,
      color: "#434146",
      fontWeight: "400"
    },
  },
  tableBodyChip: {
    width: 90,
    height: 28,


  },

  filterDate: {
    height: 54,
    gap: "10px",
    display: "flex",
    alignItems: "center",

    fontSize: 16,
    color: "#434146",
    fontWeight: "600",
    lineHeight: "18px",
  },
  informationChip: {
    marginTop: "32px",
    "& .--message": {
      marginTop: "11px",
      fontSize: 12,
      color: "#818181",
      lineHeight: "18px",
      textAlign: "center",
    },
    "& .--infocartor": {
      gap: "4px",
      display: "flex",
      alignItems: "center",

      fontSize: 14,
      color: "#434146",
      letterSpacing: "0.03rem",
      textTransform: "uppercase",

      "& div": {
        width: 28,
        height: 28,
        borderRadius: "100%"
      }
    }
  }
}))

export default ShopFloorEfficiency
